import React, { Component } from 'react';
import DataTables from './DataTables';
import Cookie from 'js-cookie';
import { Config } from '../config/config';
import { Navigate } from 'react-router-dom';
import Menu from './Menu';
import axios from 'axios';
import Header from './Header';
import Footer from './Footer';
import { ApiGateWay } from '../ApiGateWay/ApiGateWay';
import Spinner from '../UIComponents/Spinner/Spinner';
import MessageBox from '../UIComponents/MessageBox/MessageBox';
import { Helmet } from 'react-helmet';
import * as XLSX from 'xlsx';
import { INCIDENTS_DATE_GRID } from '../Utilities/AppData/Incidents/IncidentsDateGrid';
import { FORMAT_DATE } from '../Utilities/AppData/FormatDate';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import MessageBoxForInvalidPage from '../UIComponents/MessageBox/MessageBoxForInvalidPage';
import Multi from './MultiStores';
import LZString from 'lz-string';


class Incidents extends Component {
  constructor(props) {
    super(props);
    const config = JSON.parse(Config);
    let stores = JSON.parse(localStorage.getItem('storeData'));
    let wareHouses = JSON.parse(localStorage.getItem('warehouseData'));
    let allStores = stores.concat(wareHouses);

    // let stores = JSON.parse(Cookie.get('stores'));
    // let wareHouses = JSON.parse(Cookie.get('warehouses'));
    localStorage.removeItem('curStoreID');
    localStorage.removeItem('tabName');
    localStorage.removeItem('store_tabName');
    localStorage.removeItem('warehouse_tabName');
    const jsonData = Cookie.get('currentUser');
    let decompressedData = LZString.decompressFromBase64(jsonData);
    decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
    const user = JSON.parse(decompressedData);
    const menu = user['moduleAccess'];
    let date = new Date();
    let month = ('0' + (date.getMonth() + 1)).slice(-2);
    let day = ('0' + date.getDate()).slice(-2);
    let year = date.getFullYear();
    var daynow = new Date();
    daynow.setDate(daynow.getDate());
    var dateStringNow = daynow.toISOString().split('T')[0];
    var dayst = new Date();
    dayst.setDate(dayst.getDate() - 30);
    var dateString = dayst.toISOString().split('T')[0];
    let cities = JSON.parse(localStorage.getItem('CitiesIncidents'));
    this.state = {
      title: 'Incidents',
      alert: '',
      incType: '',
      //storeValue: stores[0].storeId,
      allStores,
      storeValue: '',
      closure: '',
      user: menu,
      pageAllowed: false,
      stores,
      wareHouses,
      modalOpen: false,
      visible: false,
      tableVisible: false,
      cityChanged: false,
      month: month,
      day: day,
      year,
      cities,
      currentCity: '',
      FromDate: dateString,
      ToDate: dateStringNow,
      codeJson: [],
      data: [],
      message: '',
      apiInterface: config['api'],
      proxyjson: [],
      loading: false,
      userID: user.userId,
      selected: [],
    };
    this.handleSelect = this.handleSelect.bind(this);
  }

  handleFromDate = (e) => {
    this.setState(
      {
        FromDate: e.target.value,
      },
      function () {}
    );
  };
  handleToDate = (e) => {
    this.setState(
      {
        ToDate: e.target.value,
      },
      function () {}
    );
  };

  handleClosure = (e) => {
    this.setState(
      {
        closure: e.target.value,
      },
      function () {}
    );
  };

  handleStoreValue = (e) => {
    this.setState(
      {
        storeValue: e.target.value,
      },
      function () {}
    );
  };
  handleAlert = (e) => {
    this.setState(
      {
        alert: e.target.value,
      },
      function () {}
    );
  };

  handleInctype = (e) => {
    this.setState(
      {
        incType: e.target.value,
      },
      function () {}
    );
  };

  fileDownload(documentPath) {
    this.setState({
      loading: true,
      modalOpen: false,
    });
    let headers = {
      Authorization: 'Bearer ' + JSON.parse(Cookie.get('token')),
      'Access-Control-Allow-Origin': '*',
      'x-api-key': process.env.REACT_APP_X_API_KEY,
    };
    axios
      .get(
        process.env.REACT_APP_UPLOAD_DOWNLOAD +
          this.state.apiInterface +
          '/download?objectId=' +
          documentPath,
        {
          headers: headers,
          responseType: 'blob',
        }
      )
      .then((response) => {
        //Create a Blob from the PDF Stream

        var re = /(?:\.([^.]+))?$/;

        var ext = re.exec(documentPath)[1]; // "txt"
        const MimeTypesMap = {
          png: 'image/png',
          gif: 'image/gif',
          jpg: 'image/jpg',
          jpeg: 'image/jpeg',
          pdf: 'application/pdf',
          mp4: 'video/mp4',
          doc: 'application/msword',
          docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          ppt: 'application/vnd.ms-powerpoint',
          pptx: 'application/vnd.ms-powerpoint',
          xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        };

        const mimeType = MimeTypesMap[ext];

        const file = new Blob([response.data], { type: mimeType });
        //Build a URL from the file
        const fileURL = URL.createObjectURL(file);
        //Open the URL on new Window
        if (mimeType === 'application/pdf') {
          window.open(fileURL, '_blank');
        } else {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', documentPath); //or any other extension
          document.body.appendChild(link);
          link.click();
        }
        this.setState({
          loading: false,
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          modalOpen: true,
          message: 'Unable to retrieve the data. Please try again later',
        });
      });
  }

  handleSelect(fromDate = this.state.FromDate, toDate = this.state.ToDate) {
    this.setState({
      loading: true,
      cityChanged: false,
    });
    let storesForMultiSearch = this.state.allStores;

    let multiSearchData = JSON.parse(localStorage.getItem('incidentStores'));
    //alert(JSON.stringify(multiSearchData));

    storesForMultiSearch.map((value) => {
      value.activeFlag = 0;

      JSON.parse(multiSearchData.data).map((val) => {
        if (val.label === value.storeName) {
          value.activeFlag = 1;
        }
      });
    });
    this.setState({
      selected: JSON.parse(multiSearchData.data),
    });
    let ids = JSON.parse(multiSearchData.data).map((val) => val.value);
    ApiGateWay.Get(
      this.state.apiInterface +
        '/fetchStoreWiseAlertLevelCategoryToGrid?fromDate=' +
        FORMAT_DATE(this.state.FromDate) +
        '&toDate=' +
        FORMAT_DATE(toDate) +
        '&incidentType=' +
        this.state.incType +
        '&status=' +
        this.state.closure +
        '&storeId=' +
        ids +
        '&alertLevel=' +
        this.state.alert
    )
      .then((response) => response.json())
      .then((response) => {
        let body = [];
        let stores = [];
        let colorCodes = [];
        let storeID = [];
        let proxyjson = [];
        response.conditionalWebGrids.map((name, val) => {
          if (name.pdfPath == null) {
            body.push([
              name.storeName,
              name.incidentType,
              name.alertLevel,
              name.incidentCreatedBy,
              name.incidentCreatedDate,
              name.incidentClosedDate,
              name.incidentStatus,
              'No Document Available',
            ]);
          } else {
            body.push([
              name.storeName,
              name.incidentType,
              name.alertLevel,
              name.incidentCreatedBy,
              name.incidentCreatedDate,
              name.incidentClosedDate,
              name.incidentStatus,
              <a
                onClick={() => this.fileDownload(name.pdfPath)}
                style={{ cursor: 'pointer' }}
              >
                {' '}
                View Document
              </a>,
            ]);
          }

          stores.push(name.incidentDate);
          storeID.push(name.incidentDate);
          colorCodes.push([0, 0, 0, 0, 0, 0, 0, 0]);
        });

        let proxyjson1 = {
          type: 'IncidentsDateGrid',
          thead: [
            'Incident Date',
            'Store ',
            'Incident Type',
            'Alert Level',
            'Incident Created By',
            'Incident Created Date',
            'Incident Closed Date',
            'Incident Satus',
            'View Document',
          ],
          storeId: storeID,
          popUpDataGrid: 'none',
          popUpDataGridHeaders: ['Not Required'],
          tbody: body,
          columns: [
            'Incident Date',
            'Incident Type',
            'Alert Level',
            'Incident Created By',
            'Incident Created Date',
            'Incident Closed Date',
            'Incident Satus',
            'View Document',
          ],
          stores: stores,
          colorCodes: colorCodes,
          excelData: response.conditionalWebGrids,
        };

        this.setState({
          proxyjson: proxyjson1,
          data: proxyjson1.excelData,
          loading: false,
          tableVisible: true,
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          modalOpen: true,
          message: 'Unable to retrieve the data. Please try again later',
        });
      });
  }
  handleCityChange = (e) => {
    this.setState({
      currentCity: e.target.value,
      cityChanged: true,
    });
    console.log('City is changed');
    localStorage.removeItem('incidentStores');
    // localStorage.setItem(
    //   'multisearch',
    //   JSON.stringify({ type: 'retail', data: [] })
    // );
    ApiGateWay.Post(this.state.apiInterface + `/fetchStoreInfo`, {
      userId: this.state.userID,
      cityIds: e.target.value,
      appType: 'Web',
      storeType: '',
    })
      .then((response) => response.json())
      .then((response) => {
        if (
          response.errorMessage === 'Token Expired' ||
          response.errorMessage === 'Invalid Token:::JWT expired' ||
          response.errorMessage ===
            'Your session has expired. Please login again.'
        ) {
          Cookie.remove('currentUser');
          Cookie.remove('stores');
          Cookie.remove('storesAll');
          Cookie.remove('warehouses');

          localStorage.clear();
          sessionStorage.clear();
          this.setState({
            loading: false,
            modalOpen: true,
            message:
              'Your session has been expired and you will be redirected to the login page!!',
          });
          setTimeout(() => {
            return (window.location = '/');
          }, 4000);
        }

        if (response['storesInfos'][0]['storeType'] === 'Store') {
          let store = response['storesInfos'][0]['storeLocationsInfos'];
          let warehouse = response['storesInfos'][1]['storeLocationsInfos'];
          let allStores = store.concat(warehouse);
          this.setState({
            navigate1: true,
            allStores: allStores,
          });
        } else {
          let store = response['storesInfos'][1]['storeLocationsInfos'];
          let warehouse = response['storesInfos'][0]['storeLocationsInfos'];
          let allStores = store.concat(warehouse);
          this.setState({
            navigate1: true,
            allStores: allStores,
          });
        }
      })
      .catch(() => {
        this.setState({
          modalOpen: !this.state.modalOpen,
          message: 'Something went wrong please try again after sometime',
          loading: false,
        });
      });
  };
  componentDidMount() {
    let future = this.state.user;

    let pageAllow = false;

    future.map((val, index) =>
      val.value == 1
        ? !val.featureAccess
          ? val.featureName == 'Incident'
            ? (pageAllow = true)
            : ''
          : ''
        : ''
    );
    if (pageAllow) {
      this.setState({
        pageAllowed: true,
        loading: true,
      });
      ApiGateWay.Get(this.state.apiInterface + '/fetchIncidentCodes')
        .then((response) => response.json())
        .then((response) => {
          if (
            response.errorMessage === 'Token Expired' ||
            response.errorMessage === 'Invalid Token:::JWT expired' ||
            response.errorMessage ===
              'Your session has expired. Please login again.'
          ) {
            Cookie.remove('currentUser');
            Cookie.remove('stores');
            Cookie.remove('storesAll');
            Cookie.remove('warehouses');

            localStorage.clear();
            sessionStorage.clear();
            this.setState({
              loading: false,
              modalOpen: true,
              message:
                'Your session has been expired and you will be redirected to the login page!!',
            });
            setTimeout(() => {
              return (window.location = '/');
            }, 4000);
          }
          this.setState({
            codeJson: response,
            loading: false,
            visible: true,
          });
        })
        .catch((error) => {
          this.setState({
            loading: false,
            modalOpen: true,
            message: 'Unable to retrieve the data. Please try again later',
          });
        });
    } else {
      this.setState({
        pageAllowed: false,
        loading: true,
      });
    }
    //this.handleSelect("2012-11-12", "2013-03-12");
  }
  render() {
    const {
      loading,
      modalOpen,
      message,
      pageAllowed,
      cities,
      currentCity,
      storeValue,
    } = this.state;

    const exportToExcel = (data, title) => {
      const wb = XLSX.utils.book_new();
      const wsData = [
        [
          'Store Name', 'Incident Date', 'Incident Details', 'Incident Status',
          'Incident Type', 'Alert Level', 'Incident Created Date', 'Incident Decision Action Plan',
          'Incident No of Victims', 'Incident Closed Date', 'Incident Due Date', 'Incident Time'
        ],
        ...data.map(item => [
          item.storeName, item.incidentDate, item.incidentDetails, item.incidentStatus,
          item.incidentType, item.alertLevel, item.incidentCreatedDate, item.incidentDecisionActionPlan,
          item.incidentNoOfVictims, item.incidentClosedDate, item.incidentDueDate, item.incidentTime
        ])
      ];
      const ws = XLSX.utils.aoa_to_sheet(wsData);
      XLSX.utils.book_append_sheet(wb, ws, title);
      XLSX.writeFile(wb, `${title}.xlsx`);
    };

    let future = this.state.user;

    let pageAllow = false;
    return (
      <>
        {future.map((val, index) =>
          val.value == 1
            ? !val.featureAccess
              ? val.featureName == 'Incident'
                ? (pageAllow = true)
                : ''
              : ''
            : ''
        )}
        {pageAllow === false ? (
         
          <Navigate to="/pageNotAllowed" state={{ id:'Incidents' }} />
        ) : (
          ''
        )}
        <Helmet>
          <title>{this.state.title}</title>
        </Helmet>
        {modalOpen ? (
          <MessageBox
            message={message}
            signout={false}
            onClose={this.handleClose}
          />
        ) : null}

        <div className='wrapper'>
          <Header title={'Incidents'} />

          <Menu />
          <div className='content-wrapper'>
            {loading ? (
              <Spinner />
            ) : (
              <section className='content'>
                <div className='col-12'>
                <div className='row'>
                  <div className='col-md-3 '>
                    <form
                      className='IncidentStoreSelect'
                      style={{ background: 'none', padding: 'none',width:"100%" }}
                    >
                      <ToastContainer
                        position='top-right'
                        autoClose={2000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        className=''
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                      />

                      <div className='form-group'>
                        <select
                          className='form-control'
                          value={currentCity}
                          onChange={this.handleCityChange}
                        >
                          <option value=''>All Cities</option>
                          {cities &&
                            cities.cityInfos
                              .sort((a, b) =>
                                a.cityName > b.cityName ? 1 : -1
                              )
                              .map((val, index) => (
                                <option key={val.cityId} value={val.cityId}>
                                  {val.cityName}
                                </option>
                              ))}
                        </select>
                      </div>
                    </form>
                  </div>
                  <div
                    className='col-md-3 '
                    style={{
                      // width: '24%',
                      marginTop: '15px',
                      // marginLeft: '10px',
                    }}
                  >
                    <Multi
                      name='incidents'
                      cityChanged={this.state.cityChanged}
                      allStores={this.state.allStores}
                      selectedData={this.state.selected}
                    />
                    {/* <form
                      className='IncidentStoreSelect'
                      style={{ background: 'none', padding: 'none' }}
                    >
                      <div className='form-group'>
                        <select
                          className='form-control'
                          value={storeValue}
                          style={{ width: '395px' }}
                          onChange={this.handleStoreValue}
                        >
                          <option value='' disabled>
                            Select a Store
                          </option>
                          {this.state.stores
                            .sort((a, b) =>
                              a.storeName > b.storeName ? 1 : -1
                            )
                            .map((val, index) => (
                              <option key={val.storeId} value={val.storeId}>
                                {val.storeName}
                              </option>
                            ))}
                          {this.state.wareHouses
                            .sort((a, b) =>
                              a.storeName > b.storeName ? 1 : -1
                            )
                            .map((val, index) => (
                              <option key={val.storeId} value={val.storeId}>
                                {val.storeName}
                              </option>
                            ))}
                        </select>
                      </div>
                    </form> */}
                  </div>
                  <div className='col-md-3'>
                    <form
                      className='IncidentStoreSelect'
                      style={{ background: 'none', padding: 'none', width:"100%" }}
                    >
                      <div className='form-group'>
                        <input
                          value={this.state.FromDate}
                          onChange={this.handleFromDate}
                          type='date'
                          className='form-control'
                          data-inputmask="'alias': 'dd/mm/yyyy'"
                          data-mask=''
                        />
                      </div>
                    </form>
                  </div>
                  <div className='col-md-3'>
                    <form
                      className='IncidentStoreSelect'
                      style={{ background: 'none', padding: 'none', width:"100%" }}
                    >
                      <div className='form-group'>
                        <input
                          value={this.state.ToDate}
                          onChange={this.handleToDate}
                          type='date'
                          style={{ borderRadius: '7px',}}
                          className='form-control'
                          data-inputmask="'alias': 'dd/mm/yyyy'"
                          data-mask=''
                        />
                      </div>
                    </form>
                  </div>
                </div>
                </div>
                {this.state.visible ? (
                  <div className='row'>
                    <div className='col-md-3'>
                      <form
                        className='IncidentStoreSelect'
                        style={{ background: 'none', padding: 'none', width:"100%" }}
                      >
                        <div className='form-group'>
                          <select
                            className='form-control'
                            value={this.state.alert}
                            onChange={this.handleAlert}
                          >
                            <option value=''>Alert Level</option>
                            {this.state.codeJson.staticCodes
                              ? this.state.codeJson.staticCodes.map(
                                  (val, index) =>
                                    val.codeType == 'Incident Level' ? (
                                      <option
                                        key={val.codeId}
                                        value={val.codeId}
                                      >
                                        {val.codeValue}
                                      </option>
                                    ) : null
                                )
                              : null}
                          </select>
                        </div>
                      </form>
                    </div>

                    <div className='col-md-3'>
                      <form
                        className='IncidentStoreSelect'
                        style={{ background: 'none', padding: 'none', width:"100%", padding:"3% 0" }}
                      >
                        <div className='form-group'>
                          <select
                            className='form-control'
                            value={this.state.incType}
                            onChange={this.handleInctype}
                          >
                            <option value=''>Incident Type</option>
                            {this.state.codeJson.staticCodes
                              ? this.state.codeJson.staticCodes.map(
                                  (val, index) =>
                                    val.codeType == 'IncidentType' ? (
                                      <option
                                        key={val.codeId}
                                        value={val.codeId}
                                      >
                                        {val.codeValue}
                                      </option>
                                    ) : null
                                )
                              : null}
                          </select>
                        </div>
                      </form>
                    </div>

                    <div className='col-md-3'>
                      <form
                        className='IncidentStoreSelect'
                        style={{ background: 'none', padding: 'none', width:"100%" }}
                      >
                        <div className='form-group'>
                          <select
                            className='form-control'
                            value={this.state.closure}
                            onChange={this.handleClosure}
                          >
                            <option value=''>Incidents With Closure</option>
                            <option value='Close'>Yes</option>
                            <option value='Open'>No</option>
                          </select>
                        </div>
                      </form>
                    </div>

                    <div className='col-md-3'>
                      <form
                        className='IncidentStoreSelect'
                        style={{ background: 'none', padding: 'none', width:"100%" }}
                      >
                        <div className='form-group'>
                          <button
                            type='button'
                            onClick={this.handleSelect}
                            className='btn btn-secondary deca-btn-yellow'
                          >
                            SUBMIT
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                ) : null}
                <br /> <br />
                {this.state.tableVisible ? (
                  <button
                    className='btn btn-secondary deca-btn-yellow'
                    style={{ marginTop: '-100px', marginBottom: '-50px' }}
                    onClick={() => exportToExcel(this.state.data, this.state.title)}
                  >
                    Export to Excel
                  </button>
                ) : null}
                {this.state.tableVisible ? (
                  <div className='DataGridMain gridbgWhite'>
                    <div style={{ margin: '10px' }}>
                      <DataTables
                        title='DataGrid'
                        count={true}
                        storeDashboard={true}
                        data={this.state.proxyjson}
                        name='IncidentsDateGrid'
                      />
                    </div>
                  </div>
                ) : null}
              </section>
            )}
          </div>

          <Footer />
        </div>
      </>
    );
  }
}

export default Incidents;
